import { FunctionComponent, useEffect, useState } from "react";
import { converthtmltopdf } from "../../services/training-session.service";
import "./PDFPreview.scss";

export interface PDFPreviewProps {
  html: string;
  onLoadStateChange: (v: boolean) => void;
}

export const PDFPreview: FunctionComponent<PDFPreviewProps> = ({
  html,
  onLoadStateChange,
}) => {
  const [pdfUrl, setPdfUrl] = useState<string>("");

  useEffect(() => {
    const generatePdf = async () => {
      try {
        onLoadStateChange(false);
        const res = await converthtmltopdf(html);

        if (res.status === 200) {
          const base64 = res?.data?.certificateTemplate;
          const pdfURL = base64ToObjectURL(base64, "application/pdf");
          setPdfUrl(pdfURL);
          onLoadStateChange(true);
        }
      } catch (error) {
        onLoadStateChange(false);
        console.error("Error converting HTML to PDF:", error);
      }
    };

    if (html) {
      generatePdf();
    }
  }, [html]);

  useEffect(() => {
    if (pdfUrl) {
      const iframe: any = document.getElementById("pdf-frame");
      if (iframe) {
        iframe.src = pdfUrl;
      }
    }
  }, [pdfUrl]);

  function base64ToObjectURL(base64Data: string, mimeType: any) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
      const slice = byteCharacters.slice(offset, offset + 1024);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: mimeType });
    const objectURL = URL.createObjectURL(blob);
    return objectURL;
  }

  return (
    <div className="pdf-container" data-testid="pdf-container">
      {pdfUrl ? (
        <iframe
          id="pdf-frame"
          title="PDF Document Viewer"
          className="w-100 h-100"
          data-testid="pdf-frame"
        ></iframe>
      ) : (
        <div className="loader-container" data-testid="loader-container">
          <aui-loader type="content"></aui-loader>
        </div>
      )}
    </div>
  );
};
